import Injector from 'vue-inject';
import Debug from '@/util/debug';

const debug = Debug('service:FacebookPage');

export const CREATION_OPTIMIZED = 'optimized';
export const CREATION_BASIC = 'basic';

export default class FacebookPageService {
  constructor(aas) {
    this.adApiService = aas;
    this.error = null;

    this.autocompleteCache = {};
    this.creationModes = null;
  }

  autocomplete(search) {
    const cacheKey = `search:(${String(search)})`;
    if (cacheKey in this.autocompleteCache) {
      return new Promise(resolve => resolve(this.autocompleteCache[cacheKey]));
    }

    return this.adApiService.autocompleteFacebookPages(search)
      .then(res => {
        debug.info('from api: (%s) = %o', search, res);
        this.autocompleteCache[cacheKey] = res;
        return res;
      });
  }

  claim(id) {
    return this.adApiService.claimFacebookPage(id)
      .then(res => {
        debug.info('claim %d. res: %j, error: %o', Number(id), res.result, res.error);
        if (res.error) {
          throw res.error;
        }

        return res.result;
      });
  }

  loadCreationModesFromApi() {
    debug.info('loading from api');
    return this.adApiService.getCreationModes()
      .then(creationModes => this.creationModes = creationModes.map(mode => ({
        value: mode.slug,
        cost: mode.cost || 0,
        default: mode.default,
        image: mode.image || null,
      })))
      .catch(err => {
        debug.error('error while loading from api: %o', err);
        this.error = err;
        throw err;
      });
  }

  getCreationModes() {
    debug.info('getCreationModes', this.creationModes);

    if (this.error !== null) {
      return new Promise((resolve, reject) => reject(this.error));
    } else if (this.creationModes) {
      return new Promise(resolve => resolve(this.creationModes));
    }

    return this.loadCreationModesFromApi();
  }

  getDefaultCreationMode() {
    return this.getCreationModes()
      .then(modes => {
        const mode = modes.find(m => m.default);
        return mode ? mode.value : null;
      });
  }
}

Injector.service('facebookPageService', ['adApiService'], FacebookPageService);



// WEBPACK FOOTER //
// ./src/services/FacebookPageService.js